import IcTransform from "../../../../../../../../../../../Assets/Images/ImageEditorTransform.svg";
import IcCrop from "../../../../../../../../../../../Assets/Images/ImageEditorCrop.svg";
import IcFlipHorizontal from "../../../../../../../../../../../Assets/Images/ImageEditorFlipHorizontal.svg";
import IcFlipVertical from "../../../../../../../../../../../Assets/Images/ImageEditorFlipVertical.svg";
import IcRotate from "../../../../../../../../../../../Assets/Images/ImageEditorRotate.svg";
import IcEnhance from "../../../../../../../../../../../Assets/Images/ImageEditorEnhance.svg";
import IcBrightness from "../../../../../../../../../../../Assets/Images/ImageEditorBrightness.svg";
import IcContrast from "../../../../../../../../../../../Assets/Images/ImageEditorContrast.svg";
import IcSaturation from "../../../../../../../../../../../Assets/Images/ImageEditorSaturation.svg";
import IcTemperature from "../../../../../../../../../../../Assets/Images/ImageEditorTemperature.svg";
import IcFilter from "../../../../../../../../../../../Assets/Images/ImageEditorFilter.svg";
import IcAnnotate from "../../../../../../../../../../../Assets/Images/ImageEditorAnnotate.svg";
import IcDraw from "../../../../../../../../../../../Assets/Images/ImageEditorDraw.svg";
import IcEraser from "../../../../../../../../../../../Assets/Images/ImageEditorEraser.svg";
import IcText from "../../../../../../../../../../../Assets/Images/ImageEditorText.svg";

import { fabric } from "fabric";

export const ToolbarList = [
  {
    id: "transform",
    name: "Transform",
    icon: IcTransform,
    children: [
      {
        id: "crop",
        name: "Crop",
        icon: IcCrop,
      },
      {
        id: "flipHorizontal",
        name: "Flip Horizontal",
        icon: IcFlipHorizontal,
      },
      {
        id: "flipVertical",
        name: "Flip Vertical",
        icon: IcFlipVertical,
      },
      {
        id: "rotate",
        name: "Rotate",
        icon: IcRotate,
      },
    ],
  },
  {
    id: "enhance",
    name: "Enhance",
    icon: IcEnhance,
    children: [
      {
        id: "brightness",
        name: "Brightness",
        icon: IcBrightness,
      },
      {
        id: "contrast",
        name: "Contrast",
        icon: IcContrast,
      },
      {
        id: "saturation",
        name: "Saturation",
        icon: IcSaturation,
      },
      {
        id: "temperature",
        name: "Temperature",
        icon: IcTemperature,
      },
    ],
  },
  {
    id: "filter",
    name: "Filter",
    icon: IcFilter,
    children: [
      {
        id: "grey",
        name: "Grey",
      },
      {
        id: "sepia",
        name: "Sepia",
      },
      {
        id: "invert",
        name: "Invert",
      },
      {
        id: "blur",
        name: "Blur",
      },
    ],
  },
  {
    id: "annotate",
    name: "Annotate",
    icon: IcAnnotate,
    children: [
      {
        id: "draw",
        name: "Draw",
        icon: IcDraw,
      },
      {
        id: "eraser",
        name: "Eraser",
        icon: IcEraser,
      },
      {
        id: "text",
        name: "Text",
        icon: IcText,
      },
    ],
  },
];

export const drawSizeOptions = [
  {
    name: "Small",
    value: 3,
  },
  {
    name: "Medium",
    value: 6,
  },
  {
    name: "Large",
    value: 9,
  },
];

export const Filters = {
  normal: () => new fabric.Image.filters.Brightness({ brightness: 0 }),
  brightness: (intensity) =>
    new fabric.Image.filters.Brightness({ brightness: (intensity - 50) / 50 }),
  contrast: (intensity) =>
    new fabric.Image.filters.Contrast({ contrast: intensity / 50 }),
  saturation: (intensity) =>
    new fabric.Image.filters.Saturation({ saturation: intensity / 50 }),
  temperature: (intensity) =>
    new fabric.Image.filters.HueRotation({
      rotation: (2 * intensity) / 100 - 1,
    }),
  grey: (intensity) =>
    new fabric.Image.filters.CustomGrayscale({
      intensity: intensity / 100,
    }),
  sepia: (intensity) =>
    new fabric.Image.filters.CustomSepia({
      sepiaAmount: intensity / 100,
    }),
  invert: (intensity) =>
    new fabric.Image.filters.Invert({
      invertAmount: intensity / 100,
    }),
  blur: (intensity) => new fabric.Image.filters.Blur({ blur: intensity / 100 }),
};

export const renderAngleCorner = (
  ctx,
  left,
  top,
  styleOverride,
  fabricObject,
  cornerType
) => {
  const size = fabricObject.cornerSize;
  const thickness = size / 6; // Thickness of the angle arms
  const radius = thickness; // Border radius for rounded corners

  ctx.save();
  ctx.translate(left, top);
  ctx.fillStyle = fabricObject.cornerColor || "#FBCEB1";

  // Each corner needs a different path to create rounded L shapes
  switch (cornerType) {
    case "tl": // Top-left: ┌
      ctx.beginPath();
      // Start at the bottom of left arm
      ctx.moveTo(thickness, size);
      // Left arm bottom-left rounded corner
      ctx.arc(radius, size - radius, radius, Math.PI / 2, Math.PI, false);
      // Left arm left edge
      ctx.lineTo(0, radius);
      // Left arm top-left rounded corner
      ctx.arc(radius, radius, radius, Math.PI, (3 * Math.PI) / 2, false);
      // Top arm top edge
      ctx.lineTo(size - radius, 0);
      // Top arm top-right rounded corner
      ctx.arc(size - radius, radius, radius, (3 * Math.PI) / 2, 0, false);
      // Top arm right edge
      ctx.lineTo(size, thickness);
      // Inner corner - straight lines
      ctx.lineTo(thickness, thickness);
      ctx.lineTo(thickness, size);
      break;

    case "tr": // Top-right: ┐
      ctx.beginPath();
      // Start at the left of top arm
      ctx.moveTo(0, thickness);
      // Top arm top-left rounded corner
      ctx.arc(radius, radius, radius, Math.PI, (3 * Math.PI) / 2, false);
      // Top arm top edge
      ctx.lineTo(size - radius, 0);
      // Top arm top-right rounded corner
      ctx.arc(size - radius, radius, radius, (3 * Math.PI) / 2, 0, false);
      // Right arm right edge
      ctx.lineTo(size, size - radius);
      // Right arm bottom-right rounded corner
      ctx.arc(size - radius, size - radius, radius, 0, Math.PI / 2, false);
      // Right arm bottom edge
      ctx.lineTo(size - thickness, size);
      // Inner corner - straight lines
      ctx.lineTo(size - thickness, thickness);
      ctx.lineTo(0, thickness);
      break;

    case "bl": // Bottom-left: └
      ctx.beginPath();
      // Start at the top of left arm
      ctx.moveTo(thickness, 0);
      // Left arm top edge
      ctx.lineTo(0, 0);
      // Left arm left edge
      ctx.lineTo(0, size - radius);
      // Left arm bottom-left rounded corner
      ctx.arc(radius, size - radius, radius, Math.PI, Math.PI / 2, true);
      // Bottom arm bottom edge
      ctx.lineTo(size - radius, size);
      // Bottom arm bottom-right rounded corner
      ctx.arc(size - radius, size - radius, radius, Math.PI / 2, 0, true);
      // Bottom arm right edge
      ctx.lineTo(size, size - thickness);
      // Inner corner - straight lines
      ctx.lineTo(thickness, size - thickness);
      ctx.lineTo(thickness, 0);
      break;

    case "br": // Bottom-right: ┘
      ctx.beginPath();
      // Start at left edge of bottom arm
      ctx.moveTo(0, size - thickness);
      // Bottom arm left edge
      ctx.lineTo(radius, size - thickness);
      // Inner corner - straight line
      ctx.lineTo(size - thickness, size - thickness);
      // Right arm
      ctx.lineTo(size - thickness, 0);
      // Right arm top edge
      ctx.lineTo(size, 0);
      // Right arm right edge
      ctx.lineTo(size, size - radius);
      // Right arm bottom-right rounded corner
      ctx.arc(size - radius, size - radius, radius, 0, Math.PI / 2, false);
      // Bottom arm bottom edge
      ctx.lineTo(radius, size);
      // Bottom arm bottom-left rounded corner
      ctx.arc(radius, size - radius, radius, Math.PI / 2, Math.PI, false);
      // Complete the path
      ctx.lineTo(0, size - thickness);
      break;
  }

  ctx.closePath();
  ctx.fill();

  // Add an outline if needed
  if (fabricObject.cornerStrokeColor) {
    ctx.strokeStyle = fabricObject.cornerStrokeColor;
    ctx.lineWidth = 1;
    ctx.stroke();
  }

  ctx.restore();
};

// Create specific renderers for each corner
export const renderCornerTL = (ctx, left, top, styleOverride, fabricObject) => {
  // Create inset
  const cornerSize = fabricObject.cornerSize;
  const insetX = cornerSize * -0.1;
  const insetY = cornerSize * -0.1;

  renderAngleCorner(
    ctx,
    left + insetX,
    top + insetY,
    styleOverride,
    fabricObject,
    "tl"
  );
};

export const renderCornerTR = (ctx, left, top, styleOverride, fabricObject) => {
  const cornerSize = fabricObject.cornerSize;
  const insetX = cornerSize * -0.9;
  const insetY = cornerSize * -0.1;

  renderAngleCorner(
    ctx,
    left + insetX,
    top + insetY,
    styleOverride,
    fabricObject,
    "tr"
  );
};

export const renderCornerBL = (ctx, left, top, styleOverride, fabricObject) => {
  const cornerSize = fabricObject.cornerSize;
  const insetX = cornerSize * -0.1;
  const insetY = cornerSize * -0.9;

  renderAngleCorner(
    ctx,
    left + insetX,
    top + insetY,
    styleOverride,
    fabricObject,
    "bl"
  );
};

export const renderCornerBR = (ctx, left, top, styleOverride, fabricObject) => {
  const cornerSize = fabricObject.cornerSize;
  const insetX = cornerSize * -0.9;
  const insetY = cornerSize * -0.9;

  renderAngleCorner(
    ctx,
    left + insetX,
    top + insetY,
    styleOverride,
    fabricObject,
    "br"
  );
};

export const renderCornerML = (ctx, left, top, styleOverride, fabricObject) => {
  const cornerSize = fabricObject.cornerSize;
  const insetX = cornerSize * -0.1;

  ctx.save();
  ctx.fillStyle = styleOverride?.fill || "#FB4764";
  ctx.lineWidth = styleOverride?.lineWidth || 1;
  ctx.translate(left + insetX, top - 30);

  const width = 5; // Width of rectangle
  const height = 60; // Height of rectangle
  const radius = 5; // Radius for rounded corners

  // Start drawing from top-right corner
  ctx.beginPath();
  ctx.moveTo(width, 0);

  // Draw to bottom-right corner (sharp)
  ctx.lineTo(width, height);

  // Draw to bottom-left corner (rounded)
  ctx.lineTo(radius, height);
  ctx.arc(radius, height - radius, radius, Math.PI / 2, Math.PI, false);

  // Draw to top-left corner (rounded)
  ctx.lineTo(0, radius);
  ctx.arc(radius, radius, radius, Math.PI, (Math.PI * 3) / 2, false);

  // Complete the shape
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.restore();
};

export const renderCornerMR = (ctx, left, top, styleOverride, fabricObject) => {
  const cornerSize = fabricObject.cornerSize;
  const insetX = cornerSize * -0.1;
  const insetY = cornerSize * -0.9;

  ctx.save();
  ctx.fillStyle = styleOverride?.fill || "#FB4764";
  ctx.lineWidth = styleOverride?.lineWidth || 1;
  ctx.translate(left + insetX, top + insetY);

  const width = 5; // Width of rectangle
  const height = 60; // Height of rectangle
  const radius = 5; // Radius for rounded corners

  // Start drawing from top-left corner
  ctx.beginPath();
  ctx.moveTo(0, 0);

  // Draw to bottom-left corner (sharp)
  ctx.lineTo(0, height);

  // Draw to bottom-right corner (rounded)
  ctx.lineTo(width - radius, height);
  ctx.arc(width - radius, height - radius, radius, Math.PI / 2, 0, true);

  // Draw to top-right corner (rounded)
  ctx.lineTo(width, radius);
  ctx.arc(width - radius, radius, radius, 0, (Math.PI * 3) / 2, true);

  // Complete the shape
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.restore();
};

// Middle-Top corner control
export const renderCornerMT = (ctx, left, top, styleOverride, fabricObject) => {
  const cornerSize = fabricObject.cornerSize;
  const insetY = cornerSize * -0.1;

  ctx.save();
  ctx.fillStyle = styleOverride?.fill || "#FB4764";
  ctx.lineWidth = styleOverride?.lineWidth || 1;
  ctx.translate(left - 30, top + insetY);

  const width = 60; // Width of rectangle
  const height = 5; // Height of rectangle
  const radius = 5; // Radius for rounded corners

  // Start drawing from bottom-left corner
  ctx.beginPath();
  ctx.moveTo(0, height);

  // Draw to bottom-right corner (sharp)
  ctx.lineTo(width, height);

  // Draw to top-right corner (rounded)
  ctx.lineTo(width, radius);
  ctx.arc(width - radius, radius, radius, 0, (Math.PI * 3) / 2, true);

  // Draw to top-left corner (rounded)
  ctx.lineTo(radius, 0);
  ctx.arc(radius, radius, radius, (Math.PI * 3) / 2, Math.PI, true);

  // Complete the shape
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.restore();
};

// Middle-Bottom corner control
export const renderCornerMB = (ctx, left, top, styleOverride, fabricObject) => {
  const cornerSize = fabricObject.cornerSize;
  const insetY = cornerSize * -0.1;

  ctx.save();
  ctx.fillStyle = styleOverride?.fill || "#FB4764";
  ctx.lineWidth = styleOverride?.lineWidth || 1;
  ctx.translate(left - 30, top + insetY);

  const width = 60; // Width of rectangle
  const height = 5; // Height of rectangle
  const radius = 5; // Radius for rounded corners

  // Start drawing from top-left corner
  ctx.beginPath();
  ctx.moveTo(0, 0);

  // Draw to top-right corner (sharp)
  ctx.lineTo(width, 0);

  // Draw to bottom-right corner (rounded)
  ctx.lineTo(width, height - radius);
  ctx.arc(width - radius, height - radius, radius, 0, Math.PI / 2, false);

  // Draw to bottom-left corner (rounded)
  ctx.lineTo(radius, height);
  ctx.arc(radius, height - radius, radius, Math.PI / 2, Math.PI, false);

  // Complete the shape
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.restore();
};

export const renderFabricDefaultCorner = {
  tl: fabric.Object.prototype.controls.tl.render,
  tr: fabric.Object.prototype.controls.tr.render,
  bl: fabric.Object.prototype.controls.bl.render,
  br: fabric.Object.prototype.controls.br.render,
  mt: fabric.Object.prototype.controls.mt.render,
  mb: fabric.Object.prototype.controls.mb.render,
  ml: fabric.Object.prototype.controls.ml.render,
  mr: fabric.Object.prototype.controls.mr.render,
};

export const initCustomSepia = () => {
  fabric.Image.filters.CustomSepia = fabric.util.createClass(
    fabric.Image.filters.BaseFilter,
    {
      type: "CustomSepia",

      fragmentSource: `
      precision highp float;
      uniform sampler2D uTexture;
      uniform float uSepiaAmount;
      varying vec2 vTexCoord;

      void main() {
        vec4 color = texture2D(uTexture, vTexCoord);
        
        // Convert to sepia
        vec3 sepiaColor = vec3(
          dot(color.rgb, vec3(0.393, 0.769, 0.189)),
          dot(color.rgb, vec3(0.349, 0.686, 0.168)),
          dot(color.rgb, vec3(0.272, 0.534, 0.131))
        );
        
        // Mix between original and sepia based on sepia amount
        vec3 finalColor = mix(color.rgb, sepiaColor, uSepiaAmount);
        gl_FragColor = vec4(finalColor, color.a);
      }
    `,

      initialize(options) {
        this.sepiaAmount = options?.sepiaAmount || 0;
      },

      applyTo2d(options) {
        const imageData = options.imageData;
        const data = imageData.data;
        const sepiaAmount = this.sepiaAmount;

        for (let i = 0; i < data.length; i += 4) {
          const r = data[i];
          const g = data[i + 1];
          const b = data[i + 2];

          // Calculate sepia values
          const sepiaR = r * 0.393 + g * 0.769 + b * 0.189;
          const sepiaG = r * 0.349 + g * 0.686 + b * 0.168;
          const sepiaB = r * 0.272 + g * 0.534 + b * 0.131;

          // Mix between original and sepia based on sepiaAmount
          data[i] = Math.round(r + (sepiaR - r) * sepiaAmount);
          data[i + 1] = Math.round(g + (sepiaG - g) * sepiaAmount);
          data[i + 2] = Math.round(b + (sepiaB - b) * sepiaAmount);
        }
      },

      getUniformLocations(gl, program) {
        return {
          uSepiaAmount: gl.getUniformLocation(program, "uSepiaAmount"),
        };
      },

      sendUniformData(gl, uniformLocations) {
        gl.uniform1f(uniformLocations.uSepiaAmount, this.sepiaAmount);
      },

      toObject() {
        return {
          type: this.type,
          sepiaAmount: this.sepiaAmount,
        };
      },
    }
  );

  fabric.Image.filters.CustomSepia.fromObject =
    fabric.Image.filters.BaseFilter.fromObject;
};

export const initCustomGrayscale = () => {
  const GrayscaleFilter = fabric.util.createClass(
    fabric.Image.filters.BaseFilter,
    {
      type: "CustomGrayscale",

      vertexSource: `
      attribute vec2 aPosition;
      varying vec2 vTexCoord;
      void main() {
        vTexCoord = aPosition;
        gl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);
      }
    `,

      fragmentSource: `
      precision highp float;
      uniform sampler2D uTexture;
      uniform float uIntensity;
      varying vec2 vTexCoord;
      
      void main() {
        vec4 color = texture2D(uTexture, vTexCoord);
        float gray = dot(color.rgb, vec3(0.299, 0.587, 0.114));
        vec3 grayscale = vec3(gray);
        vec3 finalColor = mix(color.rgb, grayscale, uIntensity);
        gl_FragColor = vec4(finalColor, color.a);
      }
    `,

      defaults: {
        intensity: 0.5,
      },

      initialize(options) {
        options = options || {};
        this.intensity =
          options.intensity !== undefined
            ? options.intensity
            : this.defaults.intensity;
      },

      applyTo2d(options) {
        const imageData = options.imageData;
        const data = imageData.data;
        const intensity = this.intensity;

        for (let i = 0; i < data.length; i += 4) {
          const r = data[i];
          const g = data[i + 1];
          const b = data[i + 2];

          // Calculate grayscale using luminance weights
          const gray = 0.299 * r + 0.587 * g + 0.114 * b;

          // Mix between original and grayscale based on intensity
          data[i] = Math.round(r + (gray - r) * intensity);
          data[i + 1] = Math.round(g + (gray - g) * intensity);
          data[i + 2] = Math.round(b + (gray - b) * intensity);
        }
      },

      getUniformLocations(gl, program) {
        return {
          uIntensity: gl.getUniformLocation(program, "uIntensity"),
        };
      },

      sendUniformData(gl, uniformLocations) {
        gl.uniform1f(uniformLocations.uIntensity, this.intensity);
      },

      toObject() {
        return {
          type: this.type,
          intensity: this.intensity,
        };
      },
    }
  );

  // Register the filter with Fabric
  fabric.Image.filters.CustomGrayscale = GrayscaleFilter;

  // Add fromObject support for serialization
  fabric.Image.filters.CustomGrayscale.fromObject =
    fabric.Image.filters.BaseFilter.fromObject;
};

export const initCustomInvert = () => {
  // Create the filter class
  const InvertFilter = fabric.util.createClass(
    fabric.Image.filters.BaseFilter,
    {
      type: "Invert",

      // Vertex shader source - default from BaseFilter is used
      vertexSource: `
      attribute vec2 aPosition;
      varying vec2 vTexCoord;
      void main() {
        vTexCoord = aPosition;
        gl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);
      }
    `,

      // Fragment shader source
      fragmentSource: `
      precision highp float;
      uniform sampler2D uTexture;
      uniform float uInvertAmount;
      varying vec2 vTexCoord;

      void main() {
        vec4 color = texture2D(uTexture, vTexCoord);
        vec3 invertedColor = mix(color.rgb, 1.0 - color.rgb, uInvertAmount);
        gl_FragColor = vec4(invertedColor, color.a);
      }
    `,

      // Filter-specific parameters with defaults
      defaults: {
        invertAmount: 0.3,
      },

      // Constructor - needed even for arrow functions to handle defaults
      initialize(options) {
        options = options || {};
        this.invertAmount =
          options.invertAmount !== undefined
            ? options.invertAmount
            : this.defaults.invertAmount;
      },

      // 2D canvas fallback implementation
      applyTo2d(options) {
        const imageData = options.imageData;
        const data = imageData.data;
        const invertAmount = this.invertAmount;

        for (let i = 0; i < data.length; i += 4) {
          data[i] = Math.round(data[i] + (255 - 2 * data[i]) * invertAmount);
          data[i + 1] = Math.round(
            data[i + 1] + (255 - 2 * data[i + 1]) * invertAmount
          );
          data[i + 2] = Math.round(
            data[i + 2] + (255 - 2 * data[i + 2]) * invertAmount
          );
        }
      },

      // WebGL implementation
      getUniformLocations(gl, program) {
        return {
          uInvertAmount: gl.getUniformLocation(program, "uInvertAmount"),
        };
      },

      sendUniformData(gl, uniformLocations) {
        gl.uniform1f(uniformLocations.uInvertAmount, this.invertAmount);
      },

      // Needed for serialization/deserialization
      toObject() {
        return {
          type: this.type,
          invertAmount: this.invertAmount,
        };
      },
    }
  );

  // Register the filter with Fabric
  fabric.Image.filters.Invert = InvertFilter;

  // Add fromObject support for serialization
  fabric.Image.filters.Invert.fromObject =
    fabric.Image.filters.BaseFilter.fromObject;
};

export class UndoRedoHistory {
  constructor(canvas, imageRef) {
    this.canvas = canvas;
    this.imageRef = imageRef;
    this.undoStack = [];
    this.redoStack = [];
    this.isRedoing = false;

    // Save initial state
    this.saveState();
  }

  saveState() {
    if (this.isRedoing) return;

    // When a new action is performed, clear redo stack
    if (!this.isRedoing) {
      this.redoStack = [];
    }

    const currentState = this.canvas.toJSON();
    const updatedCurrentState = {
      ...currentState,
      objects: currentState?.objects?.map((obj) => ({
        ...obj,
        selectable: obj.type !== "image",
        hasControls: obj.type !== "image",
        isProtected: obj.type === "image",
      })),
    };

    const state = JSON.stringify(updatedCurrentState);

    // Only save if state is different from last state
    if (
      this.undoStack.length === 0 ||
      state !== this.undoStack[this.undoStack.length - 1]
    ) {
      this.undoStack.push(state);
      // Trigger canvas event to update state
      this.canvas.fire("history:changed");
    }
  }

  undo() {
    if (this.undoStack.length > 1) {
      this.isRedoing = true;

      // Move current state to redo stack
      const currentState = this.undoStack.pop();
      this.redoStack.push(currentState);

      // Get the previous state without removing it from undo stack
      const prevState = this.undoStack[this.undoStack.length - 1];

      // Load the previous state
      this.loadState(prevState, "history:undo");
    }
  }

  redo() {
    if (this.redoStack.length > 0) {
      this.isRedoing = true;

      // Get next state from redo stack
      const nextState = this.redoStack.pop();

      // Add it to undo stack
      this.undoStack.push(nextState);

      // Load the state
      this.loadState(nextState, "history:redo");
    }
  }

  loadState(state, eventName) {
    const parsedState = JSON.parse(state);

    this.canvas.loadFromJSON(parsedState, () => {
      // Update the fabricImage reference to the new image object
      const objects = this.canvas.getObjects();
      const newImageObject = objects.find((obj) => obj.type === "image");
      if (newImageObject && this.imageRef) {
        this.imageRef.current = newImageObject; // Update the ref
      }

      this.canvas.renderAll();
      this.canvas.fire(eventName);
      this.isRedoing = false;
    });
  }

  clear() {
    this.undoStack = [];
    this.redoStack = [];
    this.isRedoing = false;
    this.saveState();
  }

  hasUndo() {
    return this.undoStack.length > 1;
  }

  hasRedo() {
    return this.redoStack.length > 0;
  }
}
